import React from 'react';
import {
  accountSearchColumns,
  giaoDichSearchColumns,
  locationSearchColumns,
  loSearchColumns,
  QUERY_KEYS
} from '@/constants';
import { RadixHoverDropdown, FormField, SearchField } from '@/components/custom/erp';
import { SearchDialogActions, SearchDialogState } from '../../hooks';
import { Lo, TaiKhoan, ViTri } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface OtherTabProps {
  searchState: {
    state: SearchDialogState;
    actions: SearchDialogActions;
  };
}

const OtherTab: React.FC<OtherTabProps> = ({ searchState: { state, actions } }) => {
  return (
    <div className='h-96 w-[800px] min-w-[800px] space-y-4 p-4'>
      <div className='flex flex-col space-y-2'>
        {/* Mã giao dịch */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã giao dịch:</Label>
          <div className='w-[57.5%]'>
            <SearchField<MuaHangRecord>
              searchEndpoint={`/`}
              searchColumns={giaoDichSearchColumns}
              dialogTitle='Danh mục giao dịch'
              columnDisplay={`ma_giao_dich`}
              displayRelatedField={`ten_giao_dich`}
              value={state.giaoDich?.ma_giao_dich || ''}
              relatedFieldValue={state.giaoDich?.ten_giao_dich || ''}
              onRowSelection={actions.setGiaoDich}
              className='w-fit'
            />
          </div>
        </div>

        {/* Tài khoản vật tư */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tài khoản vật tư:</Label>
          <div className='w-[57.5%]'>
            <SearchField<TaiKhoan>
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              columnDisplay={`code`}
              displayRelatedField={`name`}
              value={state.taiKhoanVatTu?.code || ''}
              relatedFieldValue={state.taiKhoanVatTu?.name || ''}
              onRowSelection={actions.setTaiKhoanVatTu}
              className='w-fit'
            />
          </div>
        </div>

        {/* Tài khoản doanh thu */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tài khoản doanh thu:</Label>
          <div className='w-[57.5%]'>
            <SearchField<TaiKhoan>
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              columnDisplay={`code`}
              displayRelatedField={`name`}
              value={state.taiKhoanDoanhThu?.code || ''}
              relatedFieldValue={state.taiKhoanDoanhThu?.name || ''}
              onRowSelection={actions.setTaiKhoanDoanhThu}
              className='w-fit'
            />
          </div>
        </div>

        {/* Tài khoản giá vốn */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tài khoản giá vốn:</Label>
          <div className='w-[57.5%]'>
            <SearchField<TaiKhoan>
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              columnDisplay={`code`}
              displayRelatedField={`name`}
              value={state.taiKhoanGiaVon?.code || ''}
              relatedFieldValue={state.taiKhoanGiaVon?.name || ''}
              onRowSelection={actions.setTaiKhoanGiaVon}
              className='w-fit'
            />
          </div>
        </div>

        {/* Mã lô */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã lô:</Label>
          <div className='w-[57.5%]'>
            <SearchField<Lo>
              searchEndpoint={`/${QUERY_KEYS.LO}/`}
              searchColumns={loSearchColumns}
              dialogTitle='Danh mục lô'
              columnDisplay={`ma_lo`}
              displayRelatedField={`ten_lo`}
              value={state.lo?.ma_lo || ''}
              relatedFieldValue={state.lo?.ten_lo || ''}
              onRowSelection={actions.setLo}
              className='w-fit'
            />
          </div>
        </div>

        {/* Mã vị trí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã vị trí:</Label>
          <div className='w-[57.5%]'>
            <SearchField<ViTri>
              searchEndpoint={`/${QUERY_KEYS.VI_TRI}/`}
              searchColumns={locationSearchColumns}
              dialogTitle='Danh mục vị trí'
              columnDisplay={`ma_vi_tri`}
              displayRelatedField={`ten_vi_tri`}
              value={state.viTri?.ma_vi_tri || ''}
              relatedFieldValue={state.viTri?.ten_vi_tri || ''}
              onRowSelection={actions.setViTri}
              className='w-fit'
            />
          </div>
        </div>

        {/* Diễn giải */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Diễn giải:</Label>
          <div className='w-[57.5%]'>
            <FormField type='text' name='dien_giai' className='w-full' />
          </div>
        </div>

        {/* Mẫu lọc báo cáo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu lọc báo cáo:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='report_filtering'
              type='select'
              options={[{ value: '0', label: 'Người dùng tự lọc' }]}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={624}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => console.log('Save new filter template')
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Lưu đè vào mẫu đang chọn',
                    icon: 75,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>

        {/* Mẫu phân tích dữ liệu */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu phân tích DL:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='data_analysis_struct'
              type='select'
              options={[{ value: '0', label: 'Không phân tích' }]}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={790}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => console.log('Save new analysis template')
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Sửa mẫu đang chọn',
                    icon: 9,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTab;
